<template>
  <li
      v-if="isUserLoggedIn && isMounted"
      ref="dropdownRef"
      :class="['right setting list', { hover: isDropdownOpen }]"
      :style="{ height: isDropdownOpen ? heightRef + 'px' : undefined}"
  >
    <button class="sharp">
      <span class="small circle active gray">
        <template v-if="getUserShortName">{{ getUserShortName }}</template>
        <i class="icon-user" v-else></i>
      </span>
      <span class="hidden-lg hidden-md name">{{ getUserName }}</span>
      <a href="#" class="header-expand" role="button" aria-label="Expand List" @click="$emit('dropdownSelected', 'secondary-user-menu')">
        <i class="icon-angle-down"></i>
      </a>
    </button>
    <ul class="user-menu" v-if="loginMenu.length">
      <li v-for="(item, i) in userMenu" :key="`${item.title}-${i}`">
        <a :href="item.href">{{ item.title }}</a>
        <!-- Claimed Homes Sub-Menu -->
        <mvtMenuClaimedHomes v-if="item.showClaimedHomes" :claimedHomes="claimedHomes" />
      </li>
      <li v-for="link in loginMenu" :key="link.text">
        <a v-if="link.href" :href="link.href" :rel="link.rel">{{ link.text }}</a>
        <a v-else-if="link.event" role="button" @click="$eventBus.$emit(link.event)">{{ link.text }}</a>
      </li>
    </ul>
  </li>
  <li v-else class="right sign-in-info">
    <div class="login-signup">
      <div class="hidden-xs hidden-sm flex">
        <a @click="$eventBus.$emit('eventbus-signup', { intent: 'signin' })" href="javascript:;" role="button">Sign In</a>
        <button class="btn secondary regular" type="button" @click="$eventBus.$emit('eventbus-signup')">Join</button>
      </div>
      <div class="hidden-lg hidden-md sign-in-btn">
        <button class="btn primary small" @click="$eventBus.$emit('eventbus-signup')">Join</button>
        <button class="btn secondary small" @click="$eventBus.$emit('eventbus-signup', { intent: 'signin' })">Sign In</button>
      </div>
    </div>
  </li>
</template>

<script>
import { mapGetters } from "vuex";
import mvtMapStatic from '@/common/components/mvtmapstatic/mvt-mapstatic.vue';
import mvtMenuClaimedHomes from './mvt-header-menu-claimedhomes.vue';

export default {
  name: 'mvtHeaderMenuAuth',
  inject: ['$eventBus'],
  components: {
    mvtMapStatic,
    mvtMenuClaimedHomes,
  },
  props: [
    'user',
    'activeDropdown'
  ],
  emits: ['dropdownSelected'],
  data() {
    return {
      heightRef: null,
      isMounted: false,
    };
  },
  computed: {
    ...mapGetters('glb', ['glb', 'getSavedSearchesCount', 'getSavedHomesCount']),
    isUserLoggedIn() {
      return !!this.user?.id;
    },
    isDropdownOpen() {
      return this.activeDropdown === 'secondary-user-menu';
    },
    claimedHomes() {
      return this.user?.id ? this.glb.claimedPropertiesList || [] : [];
    },
    loginMenu() {

      const { user, appUrl } = this.glb;

      if(user?.id) {

        const role = user.role;
        const hasRole = (roles) => roles.includes(role);

        const menu = [
          {
            text: this.molang('header.AgentHelp'),
            href: 'https://agenthelp.movoto.com/',
            validation: hasRole(['AGENT', 'COBROKER_AGENT'])
          },
          {
            text: this.molang('header.profile'),
            href: `${appUrl}my-movoto/account/`,
            validation: hasRole(['AGENT', 'COBROKER_AGENT', 'NORMAL', 'MANAGEMENT'])
          },
          {
            text: this.molang('header.downloadApp'),
            href: `${appUrl}mobile/`,
            validation: true
          },
          {
            text: this.molang('header.SignOut'),
            event: 'eventbus-signout',
            validation: true,
          }
        ];

        return menu.filter(item => item.validation);

      }

      return [];

    },
    getUserShortName() {
      const names = (this.user.fullName || '').split(' ').filter(Boolean);
      return names.length ? (names[0][0] + (names[1]?.[0] || '')).toUpperCase() : '';
    },
    getUserName() {
      return this.user.fullName;
    },
    userMenu() {
      return [
        {
          /* ex: My Agent */
          title: this.molang('header.myAgent'),
          href: `${this.glb.appUrl}my-movoto/myagent/`,
        },
        {
          /* ex: Favorite Homes (#) */
          title: `${this.molang('header.savedHomes')}${this.getSavedHomesCount > 1 ? ` (${this.getSavedHomesCount})` : ''}`,
          href: `${this.glb.appUrl}my-movoto/favorites/`,
          subtitle: this.getSavedHomesCount > 1 ? this.getSavedHomesCount : undefined,
        },
        {
          /* ex: Saved Homes (#) */
          title: `${this.molang('header.savedSearches')}${this.getSavedSearchesCount > 1 ? ` (${this.getSavedSearchesCount})` : ''}`,
          href: `${this.glb.appUrl}my-movoto/saved-searches/`,
        },
        {
          /* ex: Owned Homes */
          title: this.molang('header.Homeowner'),
          href: `${this.glb.appUrl}homeowner/`,
          showClaimedHomes: true,
        },
      ];
    },
  },
  watch: {
    async isDropdownOpen(val) {
      await this.$nextTick();
      if (this.$refs.dropdownRef) {
        this.heightRef = this.$refs.dropdownRef.scrollHeight + 1;
      }
    }
  },
  mounted() {
    this.isMounted = true;
  }
};
</script>